import Domain, { DomainStrings } from 'enums/Domain'
import messageUtil from 'utils/messageUtil'

export const getAuthorUrl = (domain?: DomainStrings, author?: string) => {
  if (author) {
    switch (domain) {
      case Domain.TWITTER:
        return `https://twitter.com/${author}`
      case Domain.FACEBOOK:
        return `https://www.facebook.com/${author}`
      case Domain.INSTAGRAM:
        return `https://www.instagram.com/${author.replace('@', '')}`
      case Domain.YOUTUBE:
        return `https://www.youtube.com/channel/${author}`
      case Domain.WEIBO:
        return `http://weibo.com/u/${author}`
      case Domain.REDDIT:
        return `https://www.reddit.com/user/${author}`
      case Domain.TIKTOK:
        return `https://www.tiktok.com/@${author}`
      default:
        return undefined
    }
  } else {
    return undefined
  }
}

export const getDomainUrl = (domain?: DomainStrings) => {
  if (!domain) {
    return undefined
  }
  switch (domain) {
    case Domain.TWITTER:
      return 'https://twitter.com'
    case Domain.FACEBOOK:
      return 'https://www.facebook.com'
    case Domain.INSTAGRAM:
      return 'https://www.instagram.com'
    case Domain.YOUTUBE:
      return 'https://www.youtube.com'
    case Domain.WEIBO:
      return 'https://www.weibo.com'
    default:
      return `https://${domain}`
  }
}

export const getDomainName = (domain: DomainStrings) => {
  switch (domain) {
    case Domain.TWITTER:
      return messageUtil.sources('Twitter')
    case Domain.FACEBOOK:
      return messageUtil.sources('Facebook')
    case Domain.INSTAGRAM:
      return messageUtil.sources('Instagram')
    case Domain.YOUTUBE:
      return messageUtil.sources('YouTube')
    case Domain.TIKTOK:
      return messageUtil.sources('TikTok')
    case Domain.BLUESKY:
      return messageUtil.sources('Bluesky')
    default:
      return ''
  }
}
